import classnames from 'classnames';
import {RRule} from 'rrule';

import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import styles from './weekday-selector.module.css';

// Based on the rrule library's Weekday enum
const DAY_OPTIONS = [
    {label: 'S', value: RRule.SU.weekday},
    {label: 'M', value: RRule.MO.weekday},
    {label: 'T', value: RRule.TU.weekday},
    {label: 'W', value: RRule.WE.weekday},
    {label: 'T', value: RRule.TH.weekday},
    {label: 'F', value: RRule.FR.weekday},
    {label: 'S', value: RRule.SA.weekday},
] as const;

interface Props {
    selectedDay?: number;
    onSelect: (day: number) => void;
    isDisabled?: boolean;
}

export function WeekdaySelector(props: Props) {
    return (
        <Stack spacing={8} isHorizontal={true} alignItems='center'>
            {DAY_OPTIONS.map((dayOption) => {
                const isSelected = dayOption.value === props.selectedDay;

                return (
                    <button
                        key={`${dayOption.value.toString()}-${dayOption.label}`}
                        type='button'
                        className={classnames(styles['weekday-selector-button'], {
                            [styles['weekday-selector-button--selected']]: isSelected,
                        })}
                        onClick={() => {
                            props.onSelect(dayOption.value);
                        }}
                        disabled={props.isDisabled}
                    >
                        <Body
                            size='small'
                            isBold={isSelected}
                            color={isSelected ? 'white' : 'medium'}
                        >
                            {dayOption.label}
                        </Body>
                    </button>
                );
            })}
        </Stack>
    );
}
